import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles';
import { formatPrice } from '@components/ProductOffers/modals/ShoppingCartDrawer/utils/cartItemCard.utils';

type PromoPriceDisplayProps = {
  regularPrice: number | null;
  freeLabel?: string;
  suffix?: string;
  color?: string;
};

export const PromoPriceDisplay = ({
  regularPrice,
  freeLabel,
  suffix = '/ month',
  color,
}: PromoPriceDisplayProps): React.JSX.Element => {
  const label =
    freeLabel && regularPrice === 0
      ? freeLabel
      : regularPrice != null
        ? `${formatPrice(regularPrice)} ${suffix}`
        : '--';

  return (
    <Typography variant="price.display" noWrap sx={(theme: Theme) => ({ color: color ?? theme.colors.black })}>
      {label}
    </Typography>
  );
};
